export const featureTitle = [
  "テキスト",
  "見出し1",
  "見出し2",
  "見出し3",
  "箇条書きリスト",
  "トグルリスト",
];
